import { CLEAR_REQUESTS_DELEGATION } from "../../../../enums/MyDivision/Delegation/RequestsDelegation.types";

export const clearActiveDelegations = () => {
    return {
        type: CLEAR_REQUESTS_DELEGATION,
    }
}
